import { TRIGGER_SIDEBAR } from "./types";

export const triggerSidebar = () => {
  return {
    type: TRIGGER_SIDEBAR,
  };
};
